import {inlineError, tracer} from '@s-ui/decorators/lib'
import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
export class ValidatePhoneVerificationCodeUserUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Service} deps.getCurrentUserService
   * @param {ErrorFactory} deps.userNotLoggedInUserErrorFactory
   * @param {RequestFactory} deps.validatePhoneVerificationCodeUserRequestFactory
   * @param {Service} deps.validatePhoneVerificationCodeUserService
   */
  constructor({
    getCurrentUserService,
    userNotLoggedInUserErrorFactory,
    validatePhoneVerificationCodeUserRequestFactory,
    validatePhoneVerificationCodeUserService
  }) {
    super()
    this._getCurrentUserService = getCurrentUserService
    this._userNotLoggedInUserErrorFactory = userNotLoggedInUserErrorFactory
    this._validatePhoneVerificationCodeUserRequestFactory = validatePhoneVerificationCodeUserRequestFactory
    this._validatePhoneVerificationCodeUserService = validatePhoneVerificationCodeUserService
  }

  @tracer({metric: 'ValidatePhoneVerificationCodeUserUseCase#execute'})
  @inlineError
  async execute(params) {
    const userEntity = await this._getCurrentUserService.execute()

    if (!userEntity)
      return Promise.reject(
        this._userNotLoggedInUserErrorFactory({
          message: 'To validate phone verification code the user must be logged in'
        }).toJSON()
      )

    const validatePhoneVerificationCodeUserRequest = this._validatePhoneVerificationCodeUserRequestFactory(params)

    const [error] = await this._validatePhoneVerificationCodeUserService.execute({
      userEntity,
      validatePhoneVerificationCodeUserRequest
    })

    return error ? Promise.reject(error) : Promise.resolve()
  }
}
